module.exports = __webpack_public_path__ + "img/cloth_g1_item_13.478dbaab.svg";